import React from 'react';
import AIEduButton from '../common/Button/AIEduButton';
import AIEduDialog from '../common/Dialog/AIEduDialog';
import { useIntl } from 'react-intl';

const DeleteDeviceDialog = ({
    hideDeleteDevicesDialog,
    deleteSelectedDevices,
    visible,
    deleteMessage,
}) => {
    const intl = useIntl();
    const { formatMessage: f } = intl;
    const deleteUserDialogFooter = (
        <div className='flex justify-content-end'>
            <AIEduButton
                label='Cancel'
                className='btnSecondary mr-4'
                onClick={hideDeleteDevicesDialog}
            />
            <AIEduButton
                label='Delete'
                className='btnDelete'
                onClick={deleteSelectedDevices}
            />
        </div>
    );

    const deleteDeviceTitle = () => {
        return (
            <div
                className='flex justify-content-between pb-2'
                style={{ borderBottom: '1px solid var(--primary-background)' }}
            >
                <div>Delete Screen</div>
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={hideDeleteDevicesDialog}
                >
                    <i className='pi pi-times' />
                </div>
            </div>
        );
    };
    return (
        <AIEduDialog
            visible={visible}
            style={{ width: '40rem', fontFamily: 'SamsungOne-600, sans-serif' }}
            title={deleteDeviceTitle}
            footer={deleteUserDialogFooter}
            onHide={hideDeleteDevicesDialog}
            content={
                <>
                    <i
                        className='pi pi-exclamation-triangle mr-3'
                        style={{ fontSize: '2rem' }}
                    />
                    <span>{deleteMessage}</span>
                </>
            }
        />
    );
};

export default DeleteDeviceDialog;
